import React from "react";

import { styled } from "sharedUI/styles";
import { OrgIcon } from "./org-icon";

interface Props {
    active?: boolean;
    id: string;
    label: string;
    onClick?(): void;
    count?: number;
}

interface StyleProps {
    active: boolean;
}

const Style = styled.div<StyleProps>`
    display: flex;
    align-items: center;
    transition: background-color 0.2s ease;
    padding: 4px 6px;
    height: 36px;
    margin: 4px 0;
    border-radius: 9px;

    h3 {
        margin-left: 6px;
        font-size: 13px;
        color: ${p => p.theme.textBase};
        font-weight: 400;
        flex-grow: 1;
    }

    .count {
        font-size: 11px;
        color: ${p => p.theme.textXpale};
    }

    &.active {
        h3 {
            font-weight: 700;
            color: ${p => p.theme.textDark};
        }
        .count {
            display: none;
        }
    }

    &:not(.active):hover {
        background-color: ${p => p.theme.n100A};

        h3 {
            color: ${p => p.theme.textDark};
        }
    }
`;

export const OrgTitleSidebarItem = (props: Props) => {
    const { id, active = false, label, onClick, count } = props;
    return (
        <Style className={active ? "active" : undefined} active={active} onClick={onClick}>
            <OrgIcon size={active ? "large" : "normal"} label={label} colorSeed={id} />
            <h3>{label}</h3>
            <div className="count">{count}</div>
        </Style>
    );
};
